import { Injectable } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { Store } from '@ngrx/store';
import { combineLatest } from 'rxjs';
import { filter, map, distinctUntilChanged } from 'rxjs/operators';
import { AuthActions } from '../../../state/auth';

@Injectable({ providedIn: 'root' })
export class AuthSyncService {
  constructor(private auth: AuthService, private store: Store) {}

  start() {
    combineLatest([this.auth.isLoading$, this.auth.isAuthenticated$])
      .pipe(
        filter(([loading]) => !loading),
        map(([, isAuth]) => isAuth),
        distinctUntilChanged()
      )
      .subscribe((isAuth) => {
        this.store.dispatch(
          isAuth ? AuthActions.loginSuccess() : AuthActions.logoutSuccess()
        );
      });
  }
}
